import { Component, SimpleChanges, ViewChild,  ChangeDetectorRef } from '@angular/core';
import { MessageService } from 'base';
import { MonitorService } from 'monitor';
import { IdentityService } from 'identity';
import { MonitorEditorComponentBase } from '../MonitorEditorComponentBase';
import { PingSettingsComponent } from '../pingsettings/pingsettings.component';
import { MonitorScheduleComponent } from '../monitorschedule/monitorschedule.component';
import { MonitorEventsComponent } from '../monitorevents/monitorevents.component';
import { MonitorHistoryComponent } from '../monitorhistory/monitorhistory.component';
import { NavigationService } from 'netview';
import { Schedule } from 'DiscoveryEngine.TS/Utils';

@Component({
	selector: 'ping-monitor',
	templateUrl: './pingmonitor.component.html',
	styleUrls: ['./pingmonitor.component.scss']
})
export class PingMonitorComponent extends MonitorEditorComponentBase {

    @ViewChild(PingSettingsComponent, { static: true })
	public pingSetsComponent: PingSettingsComponent;

    @ViewChild(MonitorScheduleComponent, { static: true })
	public monSchedComponent: MonitorScheduleComponent;

    @ViewChild(MonitorEventsComponent, { static: true })
	public monEventsComponent: MonitorEventsComponent;

    @ViewChild(MonitorHistoryComponent, { static: true })
	public monHistoryComponent: MonitorHistoryComponent;
	
	constructor(monitorService: MonitorService,
		messageService: MessageService,
		identityService: IdentityService,
		navService: NavigationService,
		changeDetector: ChangeDetectorRef) {

		super(monitorService, messageService, identityService, navService, changeDetector);
	}

	public ngOnInit(): void {
		super.ngOnInit();

		this.children = [
			this.pingSetsComponent,
			this.monSchedComponent,
			this.monEventsComponent,
			this.monHistoryComponent,
		];
	}

	public ngOnChanges(changes: SimpleChanges): void {
		super.ngOnChanges(changes);
	}

	public ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	public get schedule(): Schedule {
		if (this.monSchedComponent)
			return this.monSchedComponent.value;
		else
			return new Schedule();
	}

}
